var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46066 0.795135C2.84967 0.793791 3.21835 0.971563 3.46343 1.27865L9.67287 9.11936C10.0628 9.60156 10.0628 10.2968 9.67287 10.779L3.24488 18.6197C2.79047 19.1754 1.97889 19.2515 1.43218 18.7896C0.885468 18.3277 0.810642 17.5027 1.26505 16.947L7.01168 9.94263L1.45789 2.93826C1.13689 2.54659 1.06926 2.00093 1.28466 1.54056C1.50007 1.08019 1.95918 0.789181 2.46066 0.795135Z",
    fill: "#8DB6CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.e23685c6d245e3e4baea37c848a33dd7.svg";
export { ForwardRef as ReactComponent };